import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../../images/locationgcc/dxb/banner_bg.webp";
import { StaticImage } from "gatsby-plugin-image";

function Banner({ rtl }) {
  const className = rtl ? "locationgcc_banner rtl-style" : "locationgcc_banner";
  return (
    <div className={className} style={{ backgroundImage: `url(${BgImg})` }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <h1>
                شركة تطوير تطبيقات الهاتف <span>المحمول في دبي</span>
              </h1>
              <p className="main_para">
                من تطوير تطبيقات الاندرويد إلى أي او اس، تستخدم تيك ريڤول أحدث
                التقنيات و الأدوات و والعمليات لتقديم حلول رقمية لا مثيل لها
                تخدمالشركات لتحقق نمو جذري.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                هيا بنا نبدأ
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <StaticImage
              src="../../../images/locationgcc/dxb/Growing_dubai.webp"
              alt="mobile app development company in dubai"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={775}
              height={650}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
